import { addNavMenuSection } from "@vendure/admin-ui/core";

export default [
  addNavMenuSection(
    {
      id: "custom-shipping",
      label: "Versand",
      items: [
        {
          id: "shipping-regions",
          label: "Versandregionen",
          routerLink: ["/extensions/shipping/regionen"],
          icon: "map-marker",
          requiresPermission: "UpdateSettings"
        }
      ]
    },
    "settings"
  )
];
